export default __webpack_public_path__ + "static/media/Monarch.3a777233.png";